export default [
  {
    path: '/example',
    name: 'Example',
    component: () => import('./ExampleList'),
    meta: {
      routerEdit: '/example-edit',
      routerGo: '/example-new',
      routerTravel: '',
      domain: 'Example',
      sidebar: true,
      icon: 'account_circle',
      title: 'Example',
    },
  },
];



// WEBPACK FOOTER //
// ./src/app/Example/ExampleRouter.js